// Shared site content + motion variants
export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Process", href: "#process" },
  { label: "Why Wellknowe", href: "#why" },
  { label: "FAQ", href: "#faq" },
  { label: "Enquire", href: "#contact" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Face to Face Locum Clinics",
    short: "On-site clinical cover",
    body: "Experienced Locum ANP cover in your surgery — GP locum and primary care locum capacity during staff shortages, annual leave or surges in patient demand. Seamless, safe and ready to see patients from day one.",
    image: "https://static.prod-images.emergentagent.com/jobs/cde560a8-1811-4ac4-ade7-768fd959f3fd/images/bd8fec9e6ad76d645a7fcff0273b5f47ce7c181c312e387735169ae19701b538.png",
    tags: ["GP locum", "Same-day starts", "Full clinical scope"],
  },
  {
    no: "02",
    title: "Remote Clinical Triage",
    short: "Clinical support, anywhere",
    body: "Remote primary care locum triage that absorbs demand and protects your on-site team. I assess, prioritise and safely direct patients — keeping your list moving during shortages, holidays or busy periods.",
    image: "https://images.unsplash.com/photo-1758691463606-1493d79cc577",
    tags: ["Remote", "Demand management", "Safe prioritisation"],
  },
  {
    no: "03",
    title: "Remote Clinical Workflow Admin",
    short: "Documents actioned & filed",
    body: "Working across your clinical workflow systems (such as EMIS Web and SystmOne), I read, action and file blood results, clinical documents and medication requests remotely — clearing the backlog so your clinical staff can focus on what matters most: patient care.",
    image: "https://static.prod-images.emergentagent.com/jobs/cde560a8-1811-4ac4-ade7-768fd959f3fd/images/59289a9a149bfa964b2455e097205f86b33ba03d6ab2ff749028c099edb1fc5f.png",
    tags: ["Workflow systems", "Blood results", "Medication requests"],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Continuity, not just cover.",
    body: "A locum should feel like part of your team. I integrate quickly into your systems and ways of working so patients experience seamless, safe care.",
  },
  {
    no: "02",
    title: "Protect clinical time.",
    body: "Every result filed and every triage handled remotely is time returned to your clinicians. The work fits around your practice — not the other way round.",
  },
  {
    no: "03",
    title: "Safe, senior, accountable.",
    body: "Advanced Nurse Practitioner led. Considered clinical judgement, clear documentation and full accountability on every patient contact.",
  },
];

export const PROCESS = [
  { no: "01", title: "Get in touch", body: "Tell me your cover gap — clinic days, triage support or a workflow backlog." },
  { no: "02", title: "Scope the cover", body: "We agree scope, systems access and dates that fit your surgery." },
  { no: "03", title: "Onboard fast", body: "Quick, safe onboarding to your clinical system and local protocols." },
  { no: "04", title: "Deliver & report", body: "Cover delivered with clear documentation — on-site or fully remote." },
];

export const WHY = [
  { stat: "ANP", label: "Advanced Nurse Practitioner led care" },
  { stat: "3", label: "Flexible services, one trusted provider" },
  { stat: "UK", label: "Covering GP surgeries across the UK" },
  { stat: "Remote", label: "On-site or fully remote support" },
];

export const CONTACT = {
  email: "wellknoweltd@gmail.com",
  phone: "07427 605178",
  area: "Covering GP surgeries across the United Kingdom",
  company: "Wellknowe Ltd",
};

export const FAQS = [
  {
    q: "Do you provide Locum ANP cover for GP surgeries?",
    a: "Yes. Wellknowe Ltd is a Locum ANP (Advanced Nurse Practitioner) providing experienced cover for GP surgeries and primary care teams across the UK — on-site in your surgery or remotely.",
  },
  {
    q: "Can you cover GP locum and primary care locum shifts?",
    a: "Yes. I take on GP locum and primary care locum work — face-to-face clinics and remote clinical triage — during staff shortages, annual leave and peaks in demand.",
  },
  {
    q: "Which clinical workflow systems do you work with?",
    a: "I work remotely across common primary care clinical workflow systems such as EMIS Web and SystmOne, reading, actioning and filing blood results, clinical documents and medication requests to free up your clinical time.",
  },
  {
    q: "What areas of the UK do you cover?",
    a: "Remote clinical triage and workflow admin are available to GP surgeries anywhere in the UK. Face-to-face locum clinics are arranged by location — get in touch and I'll confirm availability.",
  },
];

// Framer variants
export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const lineReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};
